import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from '@ddc/classnames-js';

const Disclaimer = ({ children }) => {
	const disclaimerClasses = ['reviews-disclaimer', 'mb-5'];
	const disclaimerTextClasses = ['reviews-disclaimer__text text-center'];
	return (
		<section className={setClassNames(disclaimerClasses)}>
			<p className={setClassNames(disclaimerTextClasses)}>{children}</p>
		</section>
	);
};

Disclaimer.propTypes = {
	children: PropTypes.node.isRequired
};

export default React.memo(Disclaimer);
